import {
    USER_LOGOUT, FETCH_ADMIN_SERVICES,DELETE_ADMIN_SERVICE,ADD_ADMIN_SERVICE,
      UPDATE_ADMIN_SERVICE,ADD_SELECTED_SERVICES,REMOVE_SELECTED_SERVICES, CLEAR_SELECTED_SERVICES  }  from "actions/actionTypes";

var _ = require('lodash');

const initialState = {data: [], fetched:false, total:0, selectedRecords:[] };
export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_ADMIN_SERVICES:
            console.log('in FETCH_ADMIN_SERVICES',action.payload );
             return {
                ...state,
                data: action.payload.data,
                total: action.payload.total,
                 fetched:true,
            }
        case ADD_ADMIN_SERVICE:
        //    console.log('ADD_ADMIN_SERVICE', state, action.payload);

            return {
                ...state,
                data: _.concat(state.data, [action.payload]),
                 total:state.total+1,
            }
        case UPDATE_ADMIN_SERVICE:
            console.log('UPDATE_ADMIN_SERVICE', state,  action.payload);
            var itemProductIndex = _.findIndex(state.data, {'_id': action.payload._id});

            var updatedProducts = [...state.data.slice(0, itemProductIndex),
                action.payload,
                ...state.data.slice(itemProductIndex + 1)];
            return {
                ...state,
                data: updatedProducts
            }

        case DELETE_ADMIN_SERVICE:
            console.log('DELETE_ADMIN_SERVICE', action.payload);
            var itemProductIndex = _.findIndex(state.data, {'_id': action.payload.recordID});
            var updatedProducts = [...state.data.slice(0, itemProductIndex),
                ...state.data.slice(itemProductIndex + 1)];
            return {
                ...state,
                total:state.total-1,
                data: updatedProducts
            }
        case ADD_SELECTED_SERVICES:
          //  console.log('ADD_SELECTED_SERVICES', state,  action.payload);
            var selectedRecordsToAdd =_.map( action.payload, function (seller) {
                return seller._id;
            });
             return {
                ...state,
                selectedRecords: _.uniq(state.selectedRecords.concat(selectedRecordsToAdd))
            }
        case CLEAR_SELECTED_SERVICES:
            console.log('CLEAR_SELECTED_SERVICES', state,  action.payload);
            return {
                ...state,
                selectedRecords: []
            }
        case REMOVE_SELECTED_SERVICES:
            console.log('REMOVE_SELECTED_SERVICES', state,  action.payload);
            var selectedRecordsToRemove =_.map( action.payload, function (seller) {
                return seller._id;
            });
            return {
                ...state,
                selectedRecords: _.uniq(_.difference(state.selectedRecords, selectedRecordsToRemove)),
            }
        case USER_LOGOUT:
            return initialState;
        default:
            return state;
    }
}

export const getRecord = (state, id) => {
     return state.adminServices.data.filter(record => record._id === id)[0];
}